import * as React from "react";
const SvgFiRrFaceScream = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-scream_svg__a)">
      <path
        fill="#062147"
        d="M0 12C0 5.383 5.383 0 12 0s12 5.383 12 12a1 1 0 1 1-2 0c0-5.514-4.486-10-10-10S2 6.486 2 12a1 1 0 1 1-2 0m13.819 9.835a10.2 10.2 0 0 1-3.639 0 .997.997 0 0 0-1.164.803 1 1 0 0 0 .803 1.164 12 12 0 0 0 4.362 0 1 1 0 1 0-.362-1.967M9.643 7.357c-.71-.71-2.246-.326-3.429.857-1.184 1.184-1.568 2.719-.857 3.429.71.71 2.246.326 3.429-.857 1.184-1.184 1.568-2.719.857-3.429m9 4.287c.71-.71.326-2.246-.857-3.43s-2.719-1.568-3.429-.857-.326 2.246.857 3.429c1.184 1.184 2.719 1.568 3.429.857zM12 13.001a3 3 0 0 0-3 3v1a3 3 0 1 0 6 0v-1a3 3 0 0 0-3-3M.901 15.335a2.004 2.004 0 0 0-.57 2.767c.015.023 1.375 2.137 1.629 4.996a.994.994 0 0 0 .991.903h2.986c.597 0 1.068-.523 1-1.116-.454-3.985-3.178-6.868-3.272-6.994-.664-.891-1.844-1.163-2.764-.556m22.202 0c-.92-.607-2.099-.335-2.763.556-.094.126-2.818 3.008-3.272 6.994a1.007 1.007 0 0 0 1 1.116h2.986a.995.995 0 0 0 .991-.903c.253-2.858 1.614-4.973 1.629-4.996a2.003 2.003 0 0 0-.571-2.767"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-scream_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceScream;
